import { render, staticRenderFns } from "./ProductsGroupEvents.vue?vue&type=template&id=6528edfa&scoped=true&"
import script from "./ProductsGroupEvents.vue?vue&type=script&lang=js&"
export * from "./ProductsGroupEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528edfa",
  null
  
)

export default component.exports